import React, { useContext, useEffect, useState } from "react";
import "./Trade_Layout.css";
import Leftmost_Toolbar from "../trade_components/leftmost_toolbar/Leftmost_Toolbar";
import Instruments from "../trade_components/instruments/Instruments";
import Main_Chart_Section from "../trade_components/main_chart_section/Main_Chart_Section";
import Economic_Calendar from "../trade_components/economic_calendar/Economic_Calendar";
import Right_End_Toolbar from "../trade_components/right_end_toolbar/Right_End_Toolbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faBriefcase,
  faExpand,
  faListUl,
} from "@fortawesome/free-solid-svg-icons";
import { Offcanvas } from "react-bootstrap";
import Portfolio from "../trade_components/main_chart_section/portfolio/Portfolio";
import { getBelowGraphData } from "../../../utils/apis/below_graph_data/below_graph";
import Deposit_Lottie from "../../animation/deposit_lottie/Deposit_Lottie";
import Successfull_Modal from "../../common_components/common_modal/successfull_modal/Successfull_Modal";
import Close_modal from "../../common_components/common_modal/close_modal/Close_modal";
import Delete_modal from "../../common_components/common_modal/delete_modal/Delete_modal";
import { getAllCompanyMarketPrice } from "../../../utils/apis/graph/graph";
import { Context } from "../../../utils/context";
import Close_Trade_Modal from "../../common_components/common_modal/close_trade_modal/Close_Trade_Modal";

const Trade_Layout = () => {
  const [modalCloseShow, setModalCloseShow] = useState(false);
  const [modalCloseTradeShow, setModalCloseTradeShow] = useState(false);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [closeTradeId, setCloseTradeId] = useState(false);
  const [selectedTab, setSelectedTab] = useState(1);
  const [showCol2, setShowCol2] = useState(true);
  const [showCol4, setShowCol4] = useState(true);
  const [showInnerTab, setShowInnerTab] = useState(false);
  const [showMobilePortfolio, setShowMobilePortfolio] = useState(false);

  const [priceHistory, setPriceHistory] = useState([]);
  const [latestCloses, setLatestCloses] = useState({}); // { [companyId]: latestClose }
  const [latestBaseCloses, setLatestBaseCloses] = useState({});

  const handleClose = () => {
    setShowCol2(false);
  };

  const handleOpen = () => {
    setShowCol2(true);
  };

  const handleClose4 = () => {
    setShowCol4(false);
  };

  const handleOpen4 = () => {
    setShowCol4(true);
  };

  const {
    IMG_URL,
    setHeaderCompanyName,
    signin,
    getuserData,
    userdata,
  } = useContext(Context);
  const [activeBtn, setActiveBtn] = useState("Open");


  const [showCol2Offcanvas, setShowCol2Offcanvas] = useState(false);

  const handleCol2OffCanvasClose = () => setShowCol2Offcanvas(false);
  const handleShowCol2OffCanvashandle = () => setShowCol2Offcanvas(true);

  const [showCol4Offcanvas, setShowCol4Offcanvas] = useState(false);

  const handleCol4OffCanvasClose = () => setShowCol4Offcanvas(false);
  const handleShowCol4OffCanvashandle = () => setShowCol4Offcanvas(true);

  const [companyId, setCompanyId] = useState(1);
  const [companyName, setCompanyName] = useState("Profcyma");

  const [latestAmount, setLatestAmount] = useState(0);
  const [CloseAmount, setCloseAmount] = useState(0);
  const [quantity, setQuantity] = useState("");
  const [latestData, setLatestData] = useState({});

  const [showModal, setShowModal] = useState(false);

  const [price, setPrice] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [name, setName] = useState("");

  const [belowGraphData, setBelowGraphData] = useState({});


  const getGraphData = async () => {
    if (signin) {
      const res = await getBelowGraphData(companyId, activeBtn);
      if (res?.success) {
        setBelowGraphData(res.data);
      }
    }
  };

  const handlePageChange = async (page) => {
    setCurrentPage(page);
    await getGraphData(name, page, perPage);
  };

  const getPriceHistory = async (name) => {
    const res = await getAllCompanyMarketPrice(name || "");
    if (res?.success) {
      setPriceHistory(res.data.data);
      setCompanyId(res.data.data[0]?.id || 1);
      setCompanyName(res.data.data[0]?.name);
      setHeaderCompanyName(res.data.data[0]?.name);
    }
  };

  useEffect(() => {
    getPriceHistory();
  }, []);

  useEffect(() => {
    getGraphData(companyId, activeBtn, currentPage, perPage);
  }, [companyId, activeBtn, currentPage, perPage]);

  return (
    <section className="Trade_Layout">
      <div className="layout_holder">
        <div className="col_1">
          <Leftmost_Toolbar
            setSelectedTab={setSelectedTab}
            handleOpen={handleOpen}
            showCol2={showCol2}
            handleShowCol4OffCanvashandle={handleShowCol4OffCanvashandle}
            handleShowCol2OffCanvashandle={handleShowCol2OffCanvashandle}
          />
        </div>
        {showCol2 && (
          <div className="col_2">
            {selectedTab === 1 && (
              <Instruments
                setCompanyId={setCompanyId}
                setCompanyName={setCompanyName}
                onClose={handleClose}
                latestAmount={latestAmount}
                priceHistory={priceHistory}
                latestCloses={latestCloses}
                setPriceHistory={setPriceHistory}
                setLatestCloses={setLatestCloses}
                getPriceHistory={getPriceHistory}
                latestBaseCloses={latestBaseCloses}
                setLatestBaseCloses={setLatestBaseCloses}
              />
            )}
            {selectedTab === 2 && <Economic_Calendar onClose={handleClose} />}
          </div>
        )}
        <div className="col_3">
          <div className="tab_holder">
            <div
              className="offcanvas_icon"
              onClick={() => {
                setShowInnerTab(true);
              }}
            >
              <FontAwesomeIcon icon={faListUl} className="tool_icon" />
              <p className="link_text">Crypto</p>
            </div>

            {/* <div
              className="offcanvas_icon"
              onClick={() => {
                setShowMobilePortfolio(true);
              }}
            >
              <FontAwesomeIcon icon={faBriefcase} className="tool_icon" />
              <p className="link_text">portfolio</p>
            </div> */}
          </div>

          <Main_Chart_Section
            companyId={companyId}
            companyName={companyName}
            setLatestAmount={setLatestAmount}
            latestAmount={latestAmount}
            setPrice={setPrice}
            price={price}
            setLatestData={setLatestData}
            latestData={latestData}
            priceHistory={priceHistory}
            latestCloses={latestCloses}
            setPriceHistory={setPriceHistory}
            setLatestCloses={setLatestCloses}
            getPriceHistory={getPriceHistory}
            latestBaseCloses={latestBaseCloses}
            setLatestBaseCloses={setLatestBaseCloses}
            getGraphData={getGraphData} //portfolio start
            onHide={() => setShowMobilePortfolio(false)}
            belowGraphData={belowGraphData}
            setActiveBtn={setActiveBtn}
            activeBtn={activeBtn}
            handlePageChange={handlePageChange}
            showClsoeModal={() => {
              setModalCloseShow(true);
            }}
            showDeleteModal={() => {
              setModalDeleteShow(true);
            }}
            showClsoeModalClose={() => {
              setModalCloseShow(false);
            }}
            showDeleteModalClose={() => {
              setModalDeleteShow(false);
            }}
            setCloseTradeId={setCloseTradeId}
            closeTradeId={closeTradeId}
          />

          <div className="desktop_portfolio_div">
            <Portfolio
              {...(activeBtn === "Open"
                ? { belowGraphData }
                : { belowGraphData })}
              onHide={() => setShowMobilePortfolio(false)}
              companyId={companyId}
              latestAmount={latestAmount}
              setActiveBtn={setActiveBtn}
              activeBtn={activeBtn}
              handlePageChange={handlePageChange}
              showClsoeModal={() => {
                setModalCloseTradeShow(true);
              }}
              showDeleteModal={() => {
                setModalDeleteShow(true);
              }}
              showClsoeModalClose={() => {
                setModalCloseTradeShow(false);
              }}
              showDeleteModalClose={() => {
                setModalDeleteShow(false);
              }}
              setModalCloseTradeShow={() => {
                setModalCloseTradeShow(false);
              }}
              setCloseTradeId={setCloseTradeId}
              closeTradeId={closeTradeId}
              setQuantity={setQuantity}
            />
          </div>
        </div>

        {showCol4 ? (
          <div className="col_4">
            <Right_End_Toolbar
              companyId={companyId}
              companyName={companyName}
              latestAmount={latestAmount}
              setPrice={setPrice}
              price={price}
              onClose={handleClose4}
              getGraphData={getGraphData}
              openSuccess={() => {
                setShowModal(true);
              }}
              openSuccessClose={() => {
                setShowModal(false);
              }}
            />
          </div>
        ) : (
          <div
            className="full_screen_icon_holder d-lg-flex"
            onClick={handleOpen4}
          >
            <FontAwesomeIcon icon={faExpand} className="expand_icon" />
          </div>
        )}
      </div>

      <Offcanvas
        className="col_2_offcanvas"
        show={showCol2Offcanvas}
        onHide={handleCol2OffCanvasClose}
        placement="start"
      >
        <Offcanvas.Body>
          <div className="">
            {selectedTab === 1 && (
              <Instruments
                setCompanyId={setCompanyId}
                setCompanyName={setCompanyName}
                companyId={companyId}
                onClose={() => {
                  handleClose();
                  setShowCol2Offcanvas(false);
                }}
                priceHistory={priceHistory}
                latestCloses={latestCloses}
                setPriceHistory={setPriceHistory}
                setLatestCloses={setLatestCloses}
                getPriceHistory={getPriceHistory}
                latestBaseCloses={latestBaseCloses}
                setLatestBaseCloses={setLatestBaseCloses}
              />
            )}
            {selectedTab === 2 && (
              <Economic_Calendar
                onClose={() => {
                  handleClose();
                  setShowCol2Offcanvas(false);
                }}
              />
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        className="col_4_offcanvas col_2_offcanvas"
        show={showCol4Offcanvas}
        onHide={handleCol4OffCanvasClose}
        placement="end"
      >
        <Offcanvas.Body>
          <div className="">
            <Right_End_Toolbar
              onClose={() => {
                handleClose();
                handleCol4OffCanvasClose(false);
              }}
              getGraphData={getGraphData}
            />
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        className="inner_menu_offcanvas"
        show={showInnerTab}
        onHide={() => setShowInnerTab(false)}
        placement="start"
      >
        <Offcanvas.Body>
          <Instruments
            setCompanyId={setCompanyId}
            setCompanyName={setCompanyName}
            companyId={companyId}
            onClose={() => {
              setShowInnerTab(false);
            }}
            priceHistory={priceHistory}
            latestCloses={latestCloses}
            setPriceHistory={setPriceHistory}
            setLatestCloses={setLatestCloses}
            getPriceHistory={getPriceHistory}
            latestBaseCloses={latestBaseCloses}
            setLatestBaseCloses={setLatestBaseCloses}
            isMobile={true}
          />
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        className="inner_menu_offcanvas"
        show={showMobilePortfolio}
        onHide={() => setShowMobilePortfolio(false)}
        placement="start"
      >
        <div className="Instruments">
          <div class="heading_part">
            <p class="heading_name">Portfolio</p>
            <div
              class="img_holder"
              onClick={() => {
                setShowMobilePortfolio(false);
              }}
            >
              <img src="/assets/images/trade/close.png" class="close_img" />
            </div>
          </div>
        </div>
        <Offcanvas.Body>
          <Portfolio
            {...(activeBtn === "Open" ? { belowGraphData } : {})}
            onHide={() => setShowMobilePortfolio(false)}
            companyId={companyId}
            belowGraphData={belowGraphData}
            latestAmount={latestAmount}
            setActiveBtn={setActiveBtn}
            activeBtn={activeBtn}
            setCloseTradeId={setCloseTradeId}
            closeTradeId={closeTradeId}
            handlePageChange={handlePageChange}
            showClsoeModal={() => {
              setModalCloseTradeShow(true);
            }}
            showDeleteModal={() => {
              setModalDeleteShow(true);
            }}
            showClsoeModalClose={() => {
              setModalCloseTradeShow(false);
            }}
            showDeleteModalClose={() => {
              setModalDeleteShow(false);
            }}
            setQuantity={setQuantity}
          />
        </Offcanvas.Body>
      </Offcanvas>

      <Close_Trade_Modal
        getGraphData={getGraphData}
        show={modalCloseTradeShow}
        closeTradeId={closeTradeId}
        amount={latestAmount}
        latestAmount={latestAmount}
        quantity={quantity}
        camount={CloseAmount}
        onHide={() => setModalCloseTradeShow(false)}
        onSubmit={() => {
          setModalCloseTradeShow(false);
          setModalCloseShow(true);
          setCloseAmount(latestAmount);
        }}
      />

      <Close_modal
        getGraphData={getGraphData}
        show={modalCloseShow}
        closeTradeId={closeTradeId}
        amount={latestAmount}
        onHide={() => setModalCloseShow(false)}
      />

      <Delete_modal
        show={modalDeleteShow}
        closeTradeId={closeTradeId}
        amount={latestAmount}
        getGraphData={getGraphData}
        getuserData={getuserData}
        userdata={userdata}
        onHide={() => setModalDeleteShow(false)}
      />

      <Successfull_Modal
        message={`Trade Successful! `}
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        lottie={<Deposit_Lottie />}
      />
    </section>
  );
};

export default Trade_Layout;
